import React from "react";
import InternalLink from "../InternalLink";
import EmptySpace from "../EmptySpace";
import { Section } from "../../sdk/Layout";
import { Button } from "../../sdk/Button";
import { ContainerExtended } from "./style";

function RequireLogin({ _t, gotoRegister }) {
    return (
        <Section>
            <ContainerExtended>
                <p>
                    {_t("youMustEnter")} <strong>{_t("youMustEnter2")}</strong>
                    {_t("youMustEnter3")}{" "}
                    <a onClick={gotoRegister}>{_t("comercialize")}</a>.
                </p>
                <InternalLink to={`/account/login`}>
                    <Button isFullWidth>Login</Button>
                </InternalLink>
                <Button isFullWidth onClick={gotoRegister} primary>
                    {_t("comercialize")}
                </Button>
            </ContainerExtended>
            <EmptySpace />
        </Section>
    );
}

export default RequireLogin;
